import { render, staticRenderFns } from "./PaymentPendingDeal.vue?vue&type=template&id=5af0a1d4&scoped=true"
import script from "./PaymentPendingDeal.vue?vue&type=script&lang=js"
export * from "./PaymentPendingDeal.vue?vue&type=script&lang=js"
import style0 from "./PaymentPendingDeal.vue?vue&type=style&index=0&id=5af0a1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0a1d4",
  null
  
)

export default component.exports